import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Delivery(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.269 3c1.104 0 2 .897 2 2v.762h3.543c1.113 0 2.129.611 2.65 1.595l2.075 3.91c.229.431.35.918.35 1.406v6.167a1 1 0 01-1 1l-1.445.001a3.037 3.037 0 01-2.864 2.032c-1.322 0-2.45-.85-2.864-2.032H9.738a3.039 3.039 0 01-2.865 2.032 3.038 3.038 0 01-2.863-2.032H3c-1.103 0-2-.898-2-2V4.998c0-1.102.897-2 2-2h9.269zM6.873 17.806c-.569 0-1.033.464-1.033 1.033a1.034 1.034 0 002.067 0c0-.569-.464-1.033-1.034-1.033zm10.705 0c-.57 0-1.034.464-1.034 1.033a1.035 1.035 0 002.067 0c0-.569-.464-1.033-1.033-1.033zm.234-10.045h-3.543V17.84h.445a3.039 3.039 0 012.864-2.033c1.323 0 2.45.85 2.864 2.034h.445v-5.168c0-.163-.04-.325-.116-.469l-2.076-3.91a.997.997 0 00-.883-.532zM12.269 13.8h-9.27v4.04h1.01a3.038 3.038 0 012.864-2.033c1.323 0 2.451.85 2.865 2.034h2.53V13.8zm0-8.8h-9.27v6.8h9.27V5z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoDelivery = React.memo(Delivery);
export default MemoDelivery;